var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('LoadingStruct',{attrs:{"is-dark":"","is-loading":_vm.loading}},[(_vm.getMode === 'gallery')?_c('Galleries'):(_vm.getMode === 'swifter')?_c('TransferChannel'):(_vm.getMode === 'clickandbuy')?_c('ClickAndBuys'):_c('Main'),_c('ErrorMessage',{attrs:{"error":_vm.error}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }